/**
 * Default DateTime format string as expected by Graph API for momentjs.
 */
export const GRAPH_DATETIME_FORMAT = 'YYYY-MM-DD[T]HH:mm:ss.SSSSSSS';
